/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

import FilterableItem from "@shared/Filterable/FilterableItem";
import {Type} from "@qwoach/class-transformer-wrapper";
import TlswMeasureStageResponse from "@shared/TlswMeasure/TlswMeasureStageResponse";
import {TlswStageEnum, TlswStageOrder} from "@shared/TlswMeasure/TlswStageEnum";
import {TlswAudienceEnum} from "@shared/TlswMeasure/TlswAudienceEnum";
import WheelSegmentItem from "@shared/WheelModel/WheelSegmentItem";

export default class TlswMeasureItem extends FilterableItem {

	clientId: string = null

	@Type(() => TlswMeasureStageResponse)
	adultStages: TlswMeasureStageResponse[] = []

	@Type(() => TlswMeasureStageResponse)
	childStages: TlswMeasureStageResponse[] = []

	constructor(options = {}) {
		let optionsObj = typeof options === "string" ? {} : options
		super(optionsObj);
		if (typeof options === "string") {
			this.clientId = options
		} else {
			this.clientId = options.clientId || this.clientId
		}
		this.ensureStages();
	}

	ensureStages(){
		if(!this.adultStages || !this.adultStages.length){
			this.adultStages = this.createDefaultStages(TlswAudienceEnum.AUDIENCE_ADULT)
		}
		if(!this.childStages || !this.childStages.length){
			this.childStages = this.createDefaultStages(TlswAudienceEnum.AUDIENCE_CHILD)
		}
	}

	createDefaultStages(audience){
		return TlswStageOrder.map(stage => new TlswMeasureStageResponse({
			stage,
			audience,
			segments: this.createDefaultSegments(),
		}))
	}

	createDefaultSegments(){
		return new Array(7).fill(null).map(() => new WheelSegmentItem(null, null, null))
	}

	getStageResponse(audience, stage){
		this.ensureStages()
		let stages = audience === TlswAudienceEnum.AUDIENCE_CHILD ? this.childStages : this.adultStages
		let response = stages.find(item => item.stage === stage)
		if(!response){
			response = new TlswMeasureStageResponse({
				stage,
				audience,
				segments: this.createDefaultSegments(),
			})
			stages.push(response)
		}
		return response
	}

	setStageResponse(audience, stage, response){
		this.ensureStages()
		let stages = audience === TlswAudienceEnum.AUDIENCE_CHILD ? this.childStages : this.adultStages
		let index = stages.findIndex(item => item.stage === stage)
		if(index >= 0){
			stages.splice(index, 1, response)
		} else {
			stages.push(response)
		}
	}
}
